import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function UMPSection() {
  return <section className="py-16 md:py-24 bg-teal-900 text-white relative overflow-hidden" data-id="element-253">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-254">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-teal-800 rounded-full blur-3xl opacity-50" data-id="element-255"></div>
        <div className="absolute bottom-0 left-1/4 w-64 h-64 bg-teal-700 rounded-full blur-3xl opacity-40" data-id="element-256"></div>
      </div>

      <div className="max-w-4xl mx-auto px-5 md:px-8 relative z-10 text-center" data-id="element-257">
        <div className="inline-flex items-center justify-center space-x-2 bg-teal-800/50 border border-teal-700 text-teal-100 px-4 py-2 rounded-full font-medium text-sm mb-8" data-id="element-258">
          <SparklesIcon className="h-4 w-4 text-teal-300" data-id="element-259" />
          <span data-id="element-260">El Descubrimiento</span>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-261">
          El Sistema de <span className="text-teal-300" data-id="element-262">Bombeo Diamante</span>
        </h2>

        <p className="text-xl md:text-2xl font-medium text-teal-100 mb-8" data-id="element-263">
          La solución no es "quemar" más, sino "calmar" más.
        </p>

        <div className="bg-white/10 backdrop-blur-md border border-white/20 p-8 md:p-10 rounded-3xl text-left space-y-6" data-id="element-264">
          <p className="text-lg text-teal-50 leading-relaxed" data-id="element-265">
            Este protocolo utiliza el{' '}
            <strong data-id="element-266">Sistema de Bombeo Diamante</strong>, una técnica de
            estimulación del nervio vago y drenaje linfático manual que puedes
            hacer en pijama.
          </p>
          <p className="text-lg text-teal-50 leading-relaxed" data-id="element-267">
            En solo <strong data-id="element-268">5 minutos</strong>, envías una señal de "seguridad"
            a tu sistema nervioso, permitiendo que tu cuerpo finalmente "suelte"
            el exceso de cortisol y el líquido estancado.
          </p>
          <div className="bg-teal-800/50 p-6 rounded-xl border-l-4 border-teal-400" data-id="element-269">
            <p className="text-xl font-bold text-white" data-id="element-270">
              Es como abrir una válvula de escape para la inflamación abdominal.
            </p>
          </div>
        </div>
      </div>
    </section>;
}